<template>
  <div ref="root" :data-row-id="rowIndex" :style="{
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingLeft: column.colId === '__meta__' ? '5px' : '10px'
  }">
<!--    {{rowUid}}-->
<!--            <div-->
<!--                class="brg-c-text"-->
<!--                :style="'max-width: ' + (col.size) + 'px;'">{{ row.data[col.prop] }}</div>-->
  </div>
</template>
<style>


</style>
<script>
import {DEBUG} from "@/components/baseGrid/GridTools";
let ctr = 0;

export default {
  name: "BgCell",

  async created() {
    this.currentModel = this.model;
  },

  async mounted() {
    if(this.column.cellRendererClass) {
      // console.log(this.column.name);
      // console.log(this.column.size);
      const input = new this.column.cellRendererClass({
        propsData: {
          rowIndex: this.rowIndex,
          prop: this.prop,
          model: this.model,
          column: this.column,
          data: this.data,
          rowUid: this.rowUid,
          hasLink: (this.hasLinkFlag && this.column.fieldConfig?.hasGridLink)
        }
      });

      this.$children.push(input);
      input.$parent = this;
      input.$root = this.$root;
      if(this.prop === "__meta__"){
        input.dataGrid = this.column.dataGrid ?? this.model.__dataStream__.streamEngine.dataGrid;
      }
      input.$mount?.();
      //input.bomb = new ArrayBuffer(2*1000*1000);
      this.input = input;
      this.$el.appendChild(input.$el);
    }
  },

  beforeUnmount(){

  },

  beforeDestroy() {
    if(this.input) {
      let input = this.input;
      input.beforeUnmount?.();
      input.$destroy?.();
      const index = this.$children.indexOf(input);
      if (index > -1) {
        this.$children.splice(index, 1);
      }
      setTimeout(() => {
        try {
          input?.afterUnmount?.();
        } finally {
          setTimeout(() => {
            input.onDestroy?.();
          });
        }
      });
      this.input = null;
    }
  },

  methods: {
    forceRequestData(){
      this.input?.forceRequestData?.();
    },
    touch(){
      if(this.input){
        //this.model.__dataStream__.loadedRows.get(this.rowIndex)

        this.currentModel = this.data[this.rowIndex];
        this.input.$props['model'] = this.currentModel;
        if (this.prop === "__meta__") {
          this.input.refreshSelection();
        }
//        DEBUG && console.log(`Touching cell row:${this.rowIndex} col:${this.column?.name} val:${this.currentModel[this.prop]}`);
      }
    }
  },

  props: {
    hasLinkFlag: {default: false},
    rowIndex: {default:-1},
    prop: {default:''},
    model: {default: null},
    column: {default: null},
    data: {default: null},
    rowUid: {default: ""}
  },

  watch: {
    rowIndex: function(val){
      if(this.input){
        this.input.$props['rowIndex'] = this.rowIndex;
        this.currentModel = this.data[this.rowIndex];
        this.input.$props['model'] = this.currentModel;
      }
    },
    prop: function(val){if(this.input){this.input.$props['prop'] = this.prop;}},
    model: function(val){
      this.currentModel = this.model;
      if(this.input){
        this.input.$props['model'] = this.model;
      }
    },
    column: function(val){
      if(this.input){
        this.input.$props['column'] = this.column;
      }
    },
    data: function(val){
      if(this.input){
        this.input.$props['data'] = this.data;
      }
    },
  },

  data: function () {
    return {
      sId: ctr++
    }
  }
}
</script>



<style scoped>
</style>